module.exports = {
    licence:{
        Robot_problem_solved:'Utile',
        Robot_problem_unsolved:'Inutile',
        Robot_emptyMassege_reminder:"Impossible d'envoyer un message vide",
        Robot_massege_ViewMore:'Afficher plus',
        Robot_massege_ViewLess:'Afficher moins',
        Robot_greetings_1:'Bonjour, que puis-je faire pour vous aider ?',
        Robot_greetings_2:"Vous cherchez quelque chose de différent ? Essayez de saisir un mot-clé afin que je puisse chercher plus d'informations à ce sujet et vous aider ! ",
        Robot_closing_1_1:"Aww, désolé ! Je suis encore en train d'apprendre. ",
        Robot_closing_1_2:"Veuillez essayer d'utiliser un autre mot-clé, ou cliquez simplement",
        Robot_closing_1_login_1:"Aww, désolé ! Je suis encore en train d'apprendre. ",
        Robot_closing_1_login_2:"S'il vous plaît essayez d'utiliser un autre mot-clé!",
        Robot_closing_2:'ICI ',
        Robot_closing_3:"pour contacter notre équipe d'assistance. Nous vous répondrons le plus rapidement possible !",
        Robot_problem_unsolved_reply:"Nous sommes désolés de ne pas pouvoir vous aider plus. J'ai bien noté votre demande pour que nous puissions améliorer notre service d'assistance ! Veuillez cliquer ICI pour contacter notre équipe d'assistance. Nous reviendrons vers vous le plus rapidement possible !",
        Robot_TypeHere:'Écrivez ici',
        Robot_greetings_label1:'Fusionnez les données dans la nouvelle application',
        Robot_greetings_label2:'Perte de données après la migration',
        Robot_greetings_label3:'La balance est déconnectée après la migration',
        Robot_greetings_label4:'Conseils après la migration',
        Robot_greetings_label5:'Graphiques affichés dans la carte',
        Robot_greetings_label6:"Afficher l’historique de poids",
        Robot_greetings_label7:"Afficher l’historique de circonférence",
        Robot_greetings_label8:'Où obtenir de l’aide',
        Robot_greetings_label9:'Autres',
        key_internet_error:"Il y ades problèmes avec le réseau. Veuillez vérifier vos paramètres réseau",
        Robot_title_Beta:'ChatBot',
        Robot_greetings_label1_login:"Oublier le mot de passe",
        Robot_greetings_label2_login:'Comment réinitialiser le mot de passe',
        Robot_greetings_label3_login:'Fusionnez les données dans la nouvelle application',
        Robot_greetings_label4_login:'Pourquoi y a-t-il deux applis ?',
        Robot_greetings_label5_login:'Notes pour la connexion au compte',
        Robot_greetings_label6_login:"La nouvelle appli a-t-elle besoin d’une nouvelle inscription ?",
        Robot_greetings_label7_login:"Que faire si j’ai un compte sur les deux applis ?",
        Robot_greetings_label8_login:'Où obtenir de l’aide',
        Robot_greetings_label9_login:'Autres',
        Robot_greetings_label1_devicePage:'Manières d’ajouter un dispositif',
        Robot_greetings_label2_devicePage:'Ajouter un dispositif à travers la fenêtre « Ajouter un dispositif »',
        Robot_greetings_label3_devicePage:'Ajouter un dispositif manuellement',
        Robot_greetings_label4_devicePage:'Conseils pour apparier une échelle Wifi-Bluetooth',
        Robot_greetings_label5_devicePage:'Comment apparier le Wifi ?',
        Robot_greetings_label6_devicePage:"Le dispositif n’apparaît pas dans la liste « DISPOSITIFS APPARIÉS »",
        Robot_greetings_label7_devicePage:"Supprimer un dispositif",
        Robot_greetings_label8_devicePage:'Où obtenir de l’aide',
        Robot_greetings_label9_devicePage:'Autres',
        Robot_greetings_label1_mePage:'Puis-je changer l’utilisateur principal ?',
        Robot_greetings_label2_mePage:'Comment modifier les renseignements de l’utilisateur principal ?',
        Robot_greetings_label3_mePage:"Voir les données d'un ami",
        Robot_greetings_label4_mePage:'Ajouter un ami',
        Robot_greetings_label5_mePage:'Comment envoyer l’invitation ?',
        Robot_greetings_label6_mePage:"Comment consulter l’invitation ?",
        Robot_greetings_label7_mePage:"Supprimer un ami",
        Robot_greetings_label8_mePage:'Où obtenir de l’aide',
        Robot_greetings_label9_mePage:'Autres',
        Robot_greetings_label1_balancePage:"Les données de poids ne sont pas synchronisées avec l'application",
        Robot_greetings_label2_balancePage:'Comment consulter l’erreur Bluetooth',
        Robot_greetings_label3_balancePage:'L’appli affiche le poids et l’IMC seulement',
        Robot_greetings_label4_balancePage:'Les lectures de muscle s’affichent en « --»',
        Robot_greetings_label5_balancePage:'Le pèse-personne ne pèse pas correctement',
        Robot_greetings_label6_balancePage:"La lecture de % de graisse corporelle varie fortement",
        Robot_greetings_label7_balancePage:"Saisir les données de poids manuellement",
        Robot_greetings_label8_balancePage:'Passez à un autre utilisateur de mesure',
        Robot_greetings_label9_balancePage:'Autres',
        Robot_greetings_label1_tapPage:'Comment utiliser le mètre-ruban',
        Robot_greetings_label2_tapPage:'Basculer vers un autre utilisateur de mesure',
        Robot_greetings_label3_tapPage:'Afficher le graphique des tendances de circonférence',
        Robot_greetings_label4_tapPage:'Afficher l’historique de circonférence',
        Robot_greetings_label5_tapPage:'Saisir les données de circonférence manuellement',
        Robot_greetings_label6_tapPage:"Où obtenir de l’aide",
        Robot_greetings_label7_tapPage:"Autres",
        savetoAlbum: 'Enregistré dans l’album',
        key_cancel: 'Annuler',
        key_confirm: 'Confirmer',
        key_deleted: 'Historique bien supprimé',
        key_delete_popup: 'L’historique ne pourra pas être récupéré après la suppression, êtes-vous sûr(e) de vouloir le supprimer ?',
        key_delete_history: 'Supprimer l’historique de conversation',
        key_delete_confirmation: 'Supprimer la confirmation'
    }
}